// extracted by mini-css-extract-plugin
module.exports = {"locationsBreadcrumbs":"az_R5","breadcrumbNav":"az_S5","breadcrumbItem":"az_T5","breadcrumbSeparator":"az_U5","noHorizontalMargin":"az_V5","noVerticalMargin":"az_W5"};